<template>
  <footer
    class="footer"
    :class="{[`footer-${type}`]: type}"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <ul>
          <li>
            <router-link to="/">
              Boigner Digital GmbH
            </router-link>
          </li>
          <li>
            <router-link to="/impressum">
              Datenschutz, Impressum &amp; AGB
            </router-link>
          </li>
        </ul>

      </nav>
      <div class="copyright">
        &copy; {{ year }} - Boigner Digital GmbH
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    props: {
      backgroundColor: String,
      type: String
    },
    data() {
      return {
        year: new Date().getFullYear()
      }
    }
  }
</script>
<style>
</style>
